module.exports = __webpack_public_path__ + "static/media/logo.a69c7ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/decoration/img/logo.png
// module id = 344
// module chunks = 0